import fetchJSON from '@api/api_helper';

const { type, key } = BF.fx.brandfolder();
const url = () => `/api/v4/${type.toLowerCase()}s/${key}/tags?per=1000`;

export const get = () => (
  fetchJSON(url())
    .then(({ data }) => data)
    .catch(async (response) => { throw (await response.json()); })
);

export const getTagNames = () => (
  fetchJSON(`${url()}?per=&names=true`)
    .then(({ data }) => data.tag_names)
    .catch(async (response) => { throw (await response.json()); })
);
